<template>
  <v-textarea
    v-model="internalValue"
    :label="field.label"
    :required="field.is_required"
    outlined
    dense
    rows="4"
  ></v-textarea>
</template>

<script>
export default {
  props: {
    modelValue: String,
    field: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      internalValue: this.modelValue,
    };
  },
  watch: {
    modelValue(newValue) {
      this.internalValue = newValue;
    },
    internalValue(newValue) {
      // this.$emit('update:modelValue', newValue);
      this.$emit('custom-update', newValue);
    },
  },
};
</script>
